module.exports = __webpack_public_path__ + "img/shibabaeva.c89de2d6.jpg";